<template>
    <layout-card
        :isCustomizable="settings.isCustomizable"
        :loading="loading"
        :type="settings.context"
        class="card-turnover card-turnover_corp"
        :error="error"
        :class="{ 'card-turnover': !error }"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
    >
        <template #title>
            {{ name }}
        </template>

        <template #content>
            <template-turnover-card :data="cardData" :currencySymbol="settings.currencySymbol" />
            <Teleport to="#dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </Teleport>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import CardMixin from './CardMixin.js';
import TemplateTurnoverCard from './TemplateTurnoverCard.vue';

export default {
    components: {
        LayoutCard,
        TemplateTurnoverCard,
    },
    mixins: [CardMixin],
    data() {
        return {
            settingsFormName: 'turnover-setting-form',
        };
    },
};
</script>
